import React from 'react';
import '../../App.css';

export default function Brotherhood(){
    return <h1 className='brotherhood'>BROTHERHOOD</h1>
}
